import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../../util/guideline'
import { BespokeRating } from '../models'
import { UpdateBespokeRating } from './UpdateBespokeRating'

interface UpdateBespokeRatingDrawerProps {
  domain: string
  bespokeRating: BespokeRating
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateBespokeRatingDrawer = ({
  domain,
  bespokeRating,
  isVisible,
  onClose,
  onSuccess,
}: UpdateBespokeRatingDrawerProps) => (
  <Drawer
    title="Update bespoke rating"
    placement="right"
    open={isVisible}
    onClose={onClose}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <UpdateBespokeRating domain={domain} bespokeRating={bespokeRating} onSuccess={onSuccess} />
  </Drawer>
)
